import 'twin.macro';
import React from 'react';
import { ReactComponent as Icon } from './floppy-disk.svg';
import { IconProps } from '@teetsh/app/src/components/Icons/icon';

export default function FloppyDisk(props: IconProps) {
  return <Icon tw="text-current" className={props.className} />;
}
